import React from 'react';
import './StatsCard.css';

const StatsCard = ({ title, value, subtitle, color }) => {
  return (
    <div className="stats-card" style={{ borderTopColor: color }}>
      <div className="stats-content">
        <h3 className="stats-title">{title}</h3>
        <div className="stats-value" style={{ color }}>
          {value}
        </div>
        {subtitle && <p className="stats-subtitle">{subtitle}</p>}
      </div>
    </div>
  );
};

export default StatsCard;
